import CLIENT from '../../../store/actions/CLIENT';
import { isPartialMatch } from '../../../utils/helpers';
import {
  GET_ACTIVE_USERS,
  GET_ACTIVE_USERS_LOADING,
  GET_ACTIVE_USERS_ERROR,
  GET_CORPORATE_LIST,
  GET_CORPORATE_LIST_LOADING,
  GET_CORPORATE_LIST_ERROR,
  DOWNLOAD_PDF,
  DOWNLOAD_PDF_LOADING,
  DOWNLOAD_PDF_ERROR,
  GET_PAID_REGISTERED_USERS_LOADING,
  GET_PAID_REGISTERED_USERS,
  GET_PAID_REGISTERED_USERS_ERROR,
  GET_KPI_DATA_LOADING,
  GET_KPI_DATA,
  GET_KPI_DATA_ERROR,
  GET_TOTAL_USERS_PLAYED_CONTENT_LOADING,
  GET_TOTAL_USERS_PLAYED_CONTENT,
  GET_TOTAL_USERS_PLAYED_CONTENT_ERROR,
  GET_USERS_RATED_THE_CONTENT_LOADING,
  GET_USERS_RATED_THE_CONTENT,
  GET_USERS_RATED_THE_CONTENT_ERROR,
  GET_USERS_FAVORITE_THE_CONTENT_LOADING,
  GET_USERS_FAVORITE_THE_CONTENT,
  GET_USERS_FAVORITE_THE_CONTENT_ERROR,
  GET_NUMBER_OF_PC_COMPLETED_LOADING,
  GET_NUMBER_OF_PC_COMPLETED,
  GET_NUMBER_OF_PC_COMPLETED_ERROR,
  GET_NUMBER_OF_PC_BOOKINGS_LOADING,
  GET_NUMBER_OF_PC_BOOKINGS,
  GET_NUMBER_OF_PC_BOOKINGS_ERROR,
  GET_NUMBER_OF_USERS_TAKE_WATER_LOADING,
  GET_NUMBER_OF_USERS_TAKE_WATER,
  GET_NUMBER_OF_USERS_TAKE_WATER_ERROR,
  GET_TOTAL_WATER_INTAKE_LOADING,
  GET_TOTAL_WATER_INTAKE,
  GET_TOTAL_WATER_INTAKE_ERROR,
  GET_TOTAL_EARNED_REWARD_POINTS_LOADING,
  GET_TOTAL_EARNED_REWARD_POINTS,
  GET_TOTAL_EARNED_REWARD_POINTS_ERROR,
  GET_TOTAL_USERS_EARNED_REWARDS_LOADING,
  GET_TOTAL_USERS_EARNED_REWARDS,
  GET_TOTAL_USERS_EARNED_REWARDS_ERROR,
  GET_TOTAL_USERS_REDEEMED_REWARDS_LOADING,
  GET_TOTAL_USERS_REDEEMED_REWARDS,
  GET_TOTAL_USERS_REDEEMED_REWARDS_ERROR,
  GET_TOTAL_PUSH_SENT_LOADING,
  GET_TOTAL_PUSH_SENT,
  GET_TOTAL_PUSH_SENT_ERROR,
  GET_TOTAL_CHALLENGES_LAUNCHED_LOADING,
  GET_TOTAL_CHALLENGES_LAUNCHED,
  GET_TOTAL_CHALLENGES_LAUNCHED_ERROR,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LOADING,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE_ERROR,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LOADING,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_ERROR,
  GET_PROGRAM_JOINED_LOADING,
  GET_PROGRAM_JOINED,
  GET_PROGRAM_JOINED_ERROR,
  GET_PROGRAM_COMPLETED_LOADING,
  GET_PROGRAM_COMPLETED,
  GET_PROGRAM_COMPLETED_ERROR,
  GET_BOOK_READ_LOADING,
  GET_BOOK_READ,
  GET_BOOK_READ_ERROR,
  GET_TOTAL_MINS_PLAYED_LOADING,
  GET_TOTAL_MINS_PLAYED,
  GET_TOTAL_MINS_PLAYED_ERROR,
  GET_TOTAL_STEPS_CAPTURED_LOADING,
  GET_TOTAL_STEPS_CAPTURED,
  GET_TOTAL_STEPS_CAPTURED_ERROR,
  GET_TOTAL_USER_SYNCING_STEPS_LOADING,
  GET_TOTAL_USER_SYNCING_STEPS,
  GET_TOTAL_USER_SYNCING_STEPS_ERROR,
  DOWNLOAD_OVERALL_REPORT_LOADING,
  DOWNLOAD_OVERALL_REPORT,
  DOWNLOAD_OVERALL_REPORT_ERROR,
  GET_INDIVIDUAL_DETAILS_LOADING,
  GET_INDIVIDUAL_DETAILS,
  GET_INDIVIDUAL_DETAILS_ERROR,
  SAVE_SELECTED_COMPANY,
  SAVE_CURRENT_DATE_RANGE_FOR_INDIVIDUAL,
  GET_TOTAL_USERS_PLAYED_CONTENT_LAST_90_DAYS,
  GET_TOTAL_MINS_PLAYED_LAST_90_DAYS,
  GET_USERS_RATED_THE_CONTENT_LAST_90_DAYS,
  GET_USERS_FAVORITE_THE_CONTENT_LAST_90_DAYS,
  GET_TOTAL_STEPS_CAPTURED_LAST_90_DAYS,
  GET_TOTAL_USER_SYNCING_STEPS_LAST_90_DAYS,
  GET_NUMBER_OF_PC_COMPLETED_LAST_90_DAYS,
  GET_NUMBER_OF_PC_BOOKINGS_LAST_90_DAYS,
  GET_NUMBER_OF_USERS_TAKE_WATER_LAST_90_DAYS,
  GET_TOTAL_EARNED_REWARD_POINTS_LAST_90_DAYS,
  GET_TOTAL_USERS_EARNED_REWARDS_LAST_90_DAYS,
  GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_90_DAYS,
  GET_TOTAL_PUSH_SENT_LAST_90_DAYS,
  GET_TOTAL_CHALLENGES_LAUNCHED_LAST_90_DAYS,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_90_DAYS,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_90_DAYS,
  GET_PROGRAM_JOINED_LAST_90_DAYS,
  GET_PROGRAM_COMPLETED_LAST_90_DAYS,
  GET_BOOK_READ_LAST_90_DAYS,
  GET_TOTAL_USERS_PLAYED_CONTENT_LAST_30_DAYS,
  GET_TOTAL_MINS_PLAYED_LAST_30_DAYS,
  GET_USERS_RATED_THE_CONTENT_LAST_30_DAYS,
  GET_USERS_FAVORITE_THE_CONTENT_LAST_30_DAYS,
  GET_TOTAL_STEPS_CAPTURED_LAST_30_DAYS,
  GET_TOTAL_USER_SYNCING_STEPS_LAST_30_DAYS,
  GET_NUMBER_OF_PC_COMPLETED_LAST_30_DAYS,
  GET_NUMBER_OF_PC_BOOKINGS_LAST_30_DAYS,
  GET_NUMBER_OF_USERS_TAKE_WATER_LAST_30_DAYS,
  GET_TOTAL_EARNED_REWARD_POINTS_LAST_30_DAYS,
  GET_TOTAL_USERS_EARNED_REWARDS_LAST_30_DAYS,
  GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_30_DAYS,
  GET_TOTAL_PUSH_SENT_LAST_30_DAYS,
  GET_TOTAL_CHALLENGES_LAUNCHED_LAST_30_DAYS,
  GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_30_DAYS,
  GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_30_DAYS,
  GET_PROGRAM_JOINED_LAST_30_DAYS,
  GET_PROGRAM_COMPLETED_LAST_30_DAYS,
  GET_BOOK_READ_LAST_30_DAYS,
  GET_ACTIVE_USERS_LAST_90_DAYS,
  GET_ACTIVE_USERS_LAST_30_DAYS,
  GET_PAID_REGISTERED_USERS_LAST_90_DAYS,
  GET_PAID_REGISTERED_USERS_LAST_30_DAYS,
  SAVE_DATE_RANGE_12_MONTHS,
  SAVE_DATE_RANGE_90_DAYS,
  SAVE_DATE_RANGE_30_DAYS,
  SAVE_DATE_RANGE_FOR_90_DAYS_INDIVIDUAL,
  SAVE_DATE_RANGE_FOR_30_DAYS_INDIVIDUAL,
  GET_INDIVIDUAL_DETAILS_LAST_90_DAYS,
  GET_INDIVIDUAL_DETAILS_LAST_30_DAYS,
  GET_AUDIO_BOOKS_ALLOCATION,
  GET_CAMPAIGN_AND_CHANNEL,
  GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_90_DAYS,
  GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_30_DAYS,
  GET_TOTAL_REDEEMED_REWARD_POINTS_LOADING,
  GET_TOTAL_REDEEMED_REWARD_POINTS,
  GET_TOTAL_REDEEMED_REWARD_POINTS_ERROR,
  GET_CAMPAIGN_DETAILS,
  GET_AUDIOBOOKS_DETAILS,
  SAVE_CORP_ID_NAME_MAP,
  GET_FREEMIUM_CORPORATE_LIST_LOADING,
  GET_FREEMIUM_CORPORATE_LIST,
  GET_FREEMIUM_CORPORATE_LIST_ERROR,
  SAVE_FREEMIUM_CORP_ID_NAME_MAP,
  SAVE_KPI_DATA_DUMP,
  DOWNLOAD_KPI_DATA_DUMP,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LOADING,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_SUCCESS,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_ERROR,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_90_DAYS,
  FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_30_DAYS,
  FETCH_TOTAL_MEALS_ADDED_LOADING,
  FETCH_TOTAL_MEALS_ADDED_SUCCESS,
  FETCH_TOTAL_MEALS_ADDED_ERROR,
  FETCH_TOTAL_MEALS_ADDED_LAST_90_DAYS,
  FETCH_TOTAL_MEALS_ADDED_LAST_30_DAYS,
  FETCH_TOTAL_AI_COACH_MESSAGES_LOADING,
  FETCH_TOTAL_AI_COACH_MESSAGES_SUCCESS,
  FETCH_TOTAL_AI_COACH_MESSAGES_ERROR,
  FETCH_TOTAL_AI_COACH_MESSAGES_LAST_90_DAYS,
  FETCH_TOTAL_AI_COACH_MESSAGES_LAST_30_DAYS,
  FETCH_UNIQUE_NUTRITION_USERS_LOADING,
  FETCH_UNIQUE_NUTRITION_USERS_SUCCESS,
  FETCH_UNIQUE_NUTRITION_USERS_ERROR,
  FETCH_UNIQUE_NUTRITION_USERS_LAST_90_DAYS,
  FETCH_UNIQUE_NUTRITION_USERS_LAST_30_DAYS,
} from './types';

export const clearKpiState = () => async (dispatch) => {
  dispatch({ type: 'CLEAR_KPI_STATE' });
};

export const resetKpiState = () => async (dispatch) => {
  dispatch({ type: 'RESET_KPI_STATE' });
};

export const resetIndividualDetailsState = (payload) => async (dispatch) => {
  dispatch({ type: 'RESET_INDIVIDUAL_DETAILS_STATE', payload });
};

export const reset90DaysIndividualDetailsState = (payload) => async (dispatch) => {
  dispatch({ type: 'RESET_90_DAYS_INDIVIDUAL_DETAILS_STATE', payload });
};

export const reset30DaysIndividualDetailsState = (payload) => async (dispatch) => {
  dispatch({ type: 'RESET_30_DAYS_INDIVIDUAL_DETAILS_STATE', payload });
};

export const hardResetKpiState = () => async (dispatch) => {
  dispatch({ type: 'HARD_RESET_KPI_STATE' });
};

export const saveCurrentDateRange = (payload) => async (dispatch, getState) => {
  dispatch({
    type: 'SAVE_CURRENT_DATE_RANGE',
    payload,
  });
};

export const saveDateRange12Months = (payload) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_DATE_RANGE_12_MONTHS,
    payload,
  });
};

export const saveDateRange90Days = (payload) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_DATE_RANGE_90_DAYS,
    payload,
  });
};

export const saveDateRange30Days = (payload) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_DATE_RANGE_30_DAYS,
    payload,
  });
};

export const saveSelectedCompany = (payload) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_SELECTED_COMPANY,
    payload,
  });
};

export const GetPaidCorporateList = (payload) => async (dispatch, getState) => {
  dispatch({ type: GET_CORPORATE_LIST_LOADING });
  return CLIENT({
    url: '/kpi/paidCorporateList',
    state: getState(),
    body: {
      viewedFrom: payload.viewedFrom,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_CORPORATE_LIST,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_CORPORATE_LIST_ERROR,
        error,
      });
    });
};

export const GetFreemiumCorporateList = (payload) => async (dispatch, getState) => {
  dispatch({ type: GET_FREEMIUM_CORPORATE_LIST_LOADING });
  return CLIENT({
    url: '/kpi/freemiumCorporateList',
    state: getState(),
    body: {
      viewedFrom: payload.viewedFrom,
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_FREEMIUM_CORPORATE_LIST,
        payload: response.data,
      });
    })
    .catch((error) => {
      return dispatch({
        type: GET_FREEMIUM_CORPORATE_LIST_ERROR,
        error,
      });
    });
};

export const saveCropIdNameMap = (payload) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_CORP_ID_NAME_MAP,
    payload,
  });
};

export const saveFreemiumCropIdNameMap = (payload) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_FREEMIUM_CORP_ID_NAME_MAP,
    payload,
  });
};

export const getPaidRegisteredUsers = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_PAID_REGISTERED_USERS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_PAID_REGISTERED_USERS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_PAID_REGISTERED_USERS_LOADING });
    }

    const response = await CLIENT({
      url: '/kpi/getPaidRegisteredUsers',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });

    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_PAID_REGISTERED_USERS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }

    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_PAID_REGISTERED_USERS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }

    return dispatch({
      type: GET_PAID_REGISTERED_USERS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_PAID_REGISTERED_USERS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_PAID_REGISTERED_USERS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_PAID_REGISTERED_USERS_ERROR,
      error,
    });
  }
};

export const GetActiveUsers = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_ACTIVE_USERS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_ACTIVE_USERS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_ACTIVE_USERS_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/activeUsers',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });

    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_ACTIVE_USERS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }

    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_ACTIVE_USERS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_ACTIVE_USERS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_ACTIVE_USERS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_ACTIVE_USERS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_ACTIVE_USERS_ERROR,
      error,
    });
  }
};

export const getKPIData = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_KPI_DATA_LOADING });
    const response = await CLIENT({
      url: '/kpi/data',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
      },
    });
    return dispatch({
      type: GET_KPI_DATA,
      payload: response.data,
    });
  } catch (error) {
    return dispatch({
      type: GET_KPI_DATA_ERROR,
      error,
    });
  }
};

export const fetchTotalUsersPlayedContent = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_USERS_PLAYED_CONTENT_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_USERS_PLAYED_CONTENT_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_USERS_PLAYED_CONTENT_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/totalUsersPlayedContent',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });

    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_PLAYED_CONTENT_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }

    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_PLAYED_CONTENT_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }

    return dispatch({
      type: GET_TOTAL_USERS_PLAYED_CONTENT,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_PLAYED_CONTENT_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_PLAYED_CONTENT_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_PLAYED_CONTENT_ERROR,
      error,
    });
  }
};

export const fetchTotalMinsPlayed = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_MINS_PLAYED_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_MINS_PLAYED_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_MINS_PLAYED_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalMinsPlayed',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_MINS_PLAYED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_MINS_PLAYED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_MINS_PLAYED,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_MINS_PLAYED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_MINS_PLAYED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_MINS_PLAYED_ERROR,
      error,
    });
  }
};

export const fetchUsersRatedContent = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_USERS_RATED_THE_CONTENT_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_USERS_RATED_THE_CONTENT_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_USERS_RATED_THE_CONTENT_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/usersRatedTheContent',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_USERS_RATED_THE_CONTENT_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_USERS_RATED_THE_CONTENT_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_USERS_RATED_THE_CONTENT,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_USERS_RATED_THE_CONTENT_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_USERS_RATED_THE_CONTENT_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_USERS_RATED_THE_CONTENT_ERROR,
      error,
    });
  }
};

export const fetchUsersFavoriteTheContent = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_USERS_FAVORITE_THE_CONTENT_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_USERS_FAVORITE_THE_CONTENT_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_USERS_FAVORITE_THE_CONTENT_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/usersFavoriteTheContent',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_USERS_FAVORITE_THE_CONTENT_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_USERS_FAVORITE_THE_CONTENT_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_USERS_FAVORITE_THE_CONTENT,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_USERS_FAVORITE_THE_CONTENT_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_USERS_FAVORITE_THE_CONTENT_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_USERS_FAVORITE_THE_CONTENT_ERROR,
      error,
    });
  }
};

export const fetchTotalStepsCaptured = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_STEPS_CAPTURED_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_STEPS_CAPTURED_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_STEPS_CAPTURED_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalStepsCaptured',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_STEPS_CAPTURED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_STEPS_CAPTURED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_STEPS_CAPTURED,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_STEPS_CAPTURED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_STEPS_CAPTURED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_STEPS_CAPTURED_ERROR,
      error,
    });
  }
};

export const fetchTotalUsersSyncingSteps = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_USER_SYNCING_STEPS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_USER_SYNCING_STEPS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_USER_SYNCING_STEPS_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalUsersSyncingSteps',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USER_SYNCING_STEPS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USER_SYNCING_STEPS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USER_SYNCING_STEPS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USER_SYNCING_STEPS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USER_SYNCING_STEPS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USER_SYNCING_STEPS_ERROR,
      error,
    });
  }
};

export const fetchNumberOfPcCompleted = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_NUMBER_OF_PC_COMPLETED_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_NUMBER_OF_PC_COMPLETED_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_NUMBER_OF_PC_COMPLETED_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/numberOfPcCompleted',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_NUMBER_OF_PC_COMPLETED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_NUMBER_OF_PC_COMPLETED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_NUMBER_OF_PC_COMPLETED,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_NUMBER_OF_PC_COMPLETED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_NUMBER_OF_PC_COMPLETED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_NUMBER_OF_PC_COMPLETED_ERROR,
      error,
    });
  }
};

export const fetchNumberOfPcBookings = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_NUMBER_OF_PC_BOOKINGS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_NUMBER_OF_PC_BOOKINGS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_NUMBER_OF_PC_BOOKINGS_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/numberOfPcBookings',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_NUMBER_OF_PC_BOOKINGS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_NUMBER_OF_PC_BOOKINGS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_NUMBER_OF_PC_BOOKINGS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_NUMBER_OF_PC_BOOKINGS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_NUMBER_OF_PC_BOOKINGS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_NUMBER_OF_PC_BOOKINGS_ERROR,
      error,
    });
  }
};

export const fetchNumberOfUsersTakeWater = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_NUMBER_OF_USERS_TAKE_WATER_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_NUMBER_OF_USERS_TAKE_WATER_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_NUMBER_OF_USERS_TAKE_WATER_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/numberOfUsersTakingWaterIntake',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_NUMBER_OF_USERS_TAKE_WATER_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_NUMBER_OF_USERS_TAKE_WATER_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_NUMBER_OF_USERS_TAKE_WATER,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_NUMBER_OF_USERS_TAKE_WATER_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_NUMBER_OF_USERS_TAKE_WATER_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_NUMBER_OF_USERS_TAKE_WATER_ERROR,
      error,
    });
  }
};

export const fetchTotalWaterIntake = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_TOTAL_WATER_INTAKE_LOADING });
    const response = await CLIENT({
      url: '/kpi/getTotalWaterIntake',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
      },
    });
    return dispatch({
      type: GET_TOTAL_WATER_INTAKE,
      payload: response.data,
    });
  } catch (error) {
    return dispatch({
      type: GET_TOTAL_WATER_INTAKE_ERROR,
      error,
    });
  }
};

export const fetchTotalEarnedRewardPoints = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_EARNED_REWARD_POINTS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_EARNED_REWARD_POINTS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_EARNED_REWARD_POINTS_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalEarnedRewardPoints',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_EARNED_REWARD_POINTS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_EARNED_REWARD_POINTS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_EARNED_REWARD_POINTS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_EARNED_REWARD_POINTS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_EARNED_REWARD_POINTS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_EARNED_REWARD_POINTS_ERROR,
      error,
    });
  }
};

export const fetchTotalRedeemedRewardPoints = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_REDEEMED_REWARD_POINTS_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalRedeemedRewardPoints',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_REDEEMED_REWARD_POINTS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_REDEEMED_REWARD_POINTS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_REDEEMED_REWARD_POINTS_ERROR,
      error,
    });
  }
};

export const fetchTotalUsersEarnedRewards = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_USERS_EARNED_REWARDS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_USERS_EARNED_REWARDS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_USERS_EARNED_REWARDS_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getNumberOfUsersEarnedRewards',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_EARNED_REWARDS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_EARNED_REWARDS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_EARNED_REWARDS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_EARNED_REWARDS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_EARNED_REWARDS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_EARNED_REWARDS_ERROR,
      error,
    });
  }
};

export const fetchTotalUsersRedeemedRewards = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_USERS_REDEEMED_REWARDS_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getNumberOfUsersRedeemedRewards',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_REDEEMED_REWARDS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_REDEEMED_REWARDS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_REDEEMED_REWARDS_ERROR,
      error,
    });
  }
};

export const fetchTotalPushSent = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_PUSH_SENT_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_PUSH_SENT_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_PUSH_SENT_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalPushSent',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_PUSH_SENT_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_PUSH_SENT_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_PUSH_SENT,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_PUSH_SENT_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_PUSH_SENT_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_PUSH_SENT_ERROR,
      error,
    });
  }
};

export const fetchTotalChallengesLaunched = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_CHALLENGES_LAUNCHED_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_CHALLENGES_LAUNCHED_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_CHALLENGES_LAUNCHED_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalChallengesLaunched',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_CHALLENGES_LAUNCHED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_CHALLENGES_LAUNCHED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_CHALLENGES_LAUNCHED,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_CHALLENGES_LAUNCHED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_CHALLENGES_LAUNCHED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_CHALLENGES_LAUNCHED_ERROR,
      error,
    });
  }
};

export const fetchTotalUsersJoinedInChallenge = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalUsersJoinedInChallenge',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_JOINED_IN_CHALLENGE_ERROR,
      error,
    });
  }
};

export const fetchTotalUsersParticipatedInChallenge = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getTotalUsersParticipatedInChallenge',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_TOTAL_USERS_PARTICIPATED_IN_CHALLENGE_ERROR,
      error,
    });
  }
};

export const fetchProgramJoined = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_PROGRAM_JOINED_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_PROGRAM_JOINED_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_PROGRAM_JOINED_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getProgramJoined',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_PROGRAM_JOINED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_PROGRAM_JOINED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_PROGRAM_JOINED,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_PROGRAM_JOINED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_PROGRAM_JOINED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_PROGRAM_JOINED_ERROR,
      error,
    });
  }
};

export const fetchProgramCompleted = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_PROGRAM_COMPLETED_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_PROGRAM_COMPLETED_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_PROGRAM_COMPLETED_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getProgramCompleted',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_PROGRAM_COMPLETED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_PROGRAM_COMPLETED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_PROGRAM_COMPLETED,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_PROGRAM_COMPLETED_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_PROGRAM_COMPLETED_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_PROGRAM_COMPLETED_ERROR,
      error,
    });
  }
};

export const fetchBookRead = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: GET_BOOK_READ_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: GET_BOOK_READ_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: GET_BOOK_READ_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getBookRead',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_BOOK_READ_LAST_90_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_BOOK_READ_LAST_30_DAYS,
        payload: {
          loading: false,
          data: response.data,
          error: null,
        },
      });
    }
    return dispatch({
      type: GET_BOOK_READ,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: GET_BOOK_READ_LAST_90_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: GET_BOOK_READ_LAST_30_DAYS,
        payload: {
          loading: false,
          data: null,
          error,
        },
      });
    }
    return dispatch({
      type: GET_BOOK_READ_ERROR,
      error,
    });
  }
};

export const getIndividualDetails = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilterType === 'last90Days') {
      dispatch({
        type: GET_INDIVIDUAL_DETAILS_LAST_90_DAYS,
        payload: { loading: true },
      });
    } else if (payload.selectedFilterType === 'last30Days') {
      dispatch({
        type: GET_INDIVIDUAL_DETAILS_LAST_30_DAYS,
        payload: { loading: true },
      });
    } else {
      dispatch({ type: GET_INDIVIDUAL_DETAILS_LOADING });
    }
    const response = await CLIENT({
      url: '/kpi/getIndividualDetails',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        field: payload.field,
        selectedFilterType: payload.selectedFilterType,
      },
    });

    if (payload.selectedFilterType === 'last90Days') {
      return dispatch({
        type: GET_INDIVIDUAL_DETAILS_LAST_90_DAYS,
        payload: {
          loading: false,
          data: { [payload.field]: response.data },
          error: null,
        },
      });
    }
    if (payload.selectedFilterType === 'last30Days') {
      return dispatch({
        type: GET_INDIVIDUAL_DETAILS_LAST_30_DAYS,
        payload: {
          loading: false,
          data: { [payload.field]: response.data },
          error: null,
        },
      });
    }

    const storedList = getState().kpi.individualDetails.data?.[payload.field] || [];

    if (!payload.hardRefresh && storedList.length) {
      // have  to merge data. each existing enterprises month record should be merged with incoming data
      let newList = [];
      const corpAddedToList = {};
      for (let i = 0; i < storedList.length; i++) {
        const storedItem = storedList[i];
        const matchedEnterprise = response.data.find(
          (item) => item.corporate_id === storedItem.corporate_id
        );
        if (matchedEnterprise) {
          const incomingRecordForExistingEnterprise = matchedEnterprise.data;
          for (let j = 0; j < incomingRecordForExistingEnterprise.length; j++) {
            let found = false;
            for (let k = 0; k < storedItem.data.length; k++) {
              if (
                isPartialMatch(
                  storedItem.data[k].active_date,
                  incomingRecordForExistingEnterprise[j].active_date
                )
              ) {
                storedItem.data[k] = incomingRecordForExistingEnterprise[j];
                found = true;
              }
            }
            if (!found) {
              storedItem.data.push(incomingRecordForExistingEnterprise[j]);
            }
          }
          storedItem.data = storedItem.data.sort(
            (a, b) => new Date(a.active_date) - new Date(b.active_date)
          );
          newList.push(storedItem);
          corpAddedToList[matchedEnterprise.corporate_id] = true;
        } else {
          newList.push(storedItem);
        }
      }
      // adding new enterprises
      for (let i = 0; i < response.data.length; i++) {
        if (!corpAddedToList[response.data[i].corporate_id]) {
          newList.push(response.data[i]);
        }
      }
      return dispatch({
        type: GET_INDIVIDUAL_DETAILS,
        payload: {
          [payload.field]: newList,
        },
      });
    } else {
      return dispatch({
        type: GET_INDIVIDUAL_DETAILS,
        payload: {
          [payload.field]: response.data,
        },
      });
    }
  } catch (error) {
    console.log(error);
    if (payload.selectedFilterType === 'last90Days') {
      return dispatch({
        type: GET_INDIVIDUAL_DETAILS_LAST_90_DAYS,
        payload: {
          loading: false,
          error,
        },
      });
    }
    if (payload.selectedFilterType === 'last30Days') {
      return dispatch({
        type: GET_INDIVIDUAL_DETAILS_LAST_30_DAYS,
        payload: {
          loading: false,
          error,
        },
      });
    }
    return dispatch({
      type: GET_INDIVIDUAL_DETAILS_ERROR,
      error,
    });
  }
};

export const getAudiobooksAllocationInfo = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_AUDIO_BOOKS_ALLOCATION, payload: { loading: true, error: null } });

    const response = await CLIENT({
      url: '/kpi/audiobooks-allocation-info',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        startDate: payload.startDate,
        endDate: payload.endDate,
      },
    });
    return dispatch({
      type: GET_AUDIO_BOOKS_ALLOCATION,
      payload: {
        loading: false,
        data: response.data,
        error: null,
      },
    });
  } catch (error) {
    return dispatch({
      type: GET_AUDIO_BOOKS_ALLOCATION,
      payload: {
        loading: false,
        error,
      },
    });
  }
};

export const getAudiobooksDetails = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_AUDIOBOOKS_DETAILS, payload: { loading: true, error: null } });

    const response = await CLIENT({
      url: '/kpi/audiobook-details',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        startDate: payload.startDate,
        endDate: payload.endDate,
        bookName: payload.bookName,
      },
    });
    return dispatch({
      type: GET_AUDIOBOOKS_DETAILS,
      payload: {
        loading: false,
        [payload.bookName]: response.data,
        error: null,
      },
    });
  } catch (error) {
    return dispatch({
      type: GET_AUDIOBOOKS_DETAILS,
      payload: {
        loading: false,
        error,
      },
    });
  }
};

export const getCampaignAndChannel = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_CAMPAIGN_AND_CHANNEL, payload: { loading: true, error: null } });

    const response = await CLIENT({
      url: '/kpi/campaign-and-channel',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        startDate: payload.startDate,
        endDate: payload.endDate,
      },
    });
    return dispatch({
      type: GET_CAMPAIGN_AND_CHANNEL,
      payload: {
        loading: false,
        data: response.data,
        error: null,
      },
    });
  } catch (error) {
    return dispatch({
      type: GET_CAMPAIGN_AND_CHANNEL,
      payload: {
        loading: false,
        error,
      },
    });
  }
};

export const getCampaignDetails = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_CAMPAIGN_DETAILS, payload: { loading: true, error: null } });

    const response = await CLIENT({
      url: '/kpi/campaign-details',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        startDate: payload.startDate,
        endDate: payload.endDate,
        campaign: payload.campaign,
      },
    });
    return dispatch({
      type: GET_CAMPAIGN_DETAILS,
      payload: {
        loading: false,
        [payload.campaign]: response.data,
        error: null,
      },
    });
  } catch (error) {
    return dispatch({
      type: GET_CAMPAIGN_DETAILS,
      payload: {
        loading: false,
        error,
      },
    });
  }
};

export const saveCurrentDateRangeForIndividual = (payload) => async (dispatch) => {
  dispatch({
    type: SAVE_CURRENT_DATE_RANGE_FOR_INDIVIDUAL,
    payload,
  });
};

export const saveDateRangeFor90DaysIndividual = (payload) => async (dispatch) => {
  dispatch({
    type: SAVE_DATE_RANGE_FOR_90_DAYS_INDIVIDUAL,
    payload,
  });
};

export const saveDateRangeFor30DaysIndividual = (payload) => async (dispatch) => {
  dispatch({
    type: SAVE_DATE_RANGE_FOR_30_DAYS_INDIVIDUAL,
    payload,
  });
};

export const downloadOverallReportForAllEnterprise = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: DOWNLOAD_OVERALL_REPORT_LOADING });
    const response = await CLIENT({
      url: '/kpi/getOverallDataForAllEnterprises',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        email: payload.email,
      },
    });
    return dispatch({
      type: DOWNLOAD_OVERALL_REPORT,
      payload: response.data,
    });
  } catch (error) {
    return dispatch({
      type: DOWNLOAD_OVERALL_REPORT_ERROR,
      error,
    });
  }
};

export const getKPIDumpData = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: SAVE_KPI_DATA_DUMP, payload: { loading: true, data: null, error: null } });

    const response = await CLIENT({
      url: '/kpi/data-dump',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        startDate: payload.startDate,
        endDate: payload.endDate,
        companyIdList: payload.companyIdList,
        pageNo: payload.pageNo,
        params: payload.params,
        groupByUserId: payload.groupByUserId,
      },
    });
    return dispatch({
      type: SAVE_KPI_DATA_DUMP,
      payload: {
        loading: false,
        data: response.data,
        error: null,
      },
    });
  } catch (error) {
    return dispatch({
      type: SAVE_KPI_DATA_DUMP,
      payload: {
        loading: false,
        data: null,
        error,
      },
    });
  }
};

export const downloadKPIDumpData = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: DOWNLOAD_KPI_DATA_DUMP });
    const response = await CLIENT({
      url: '/kpi/download-data-dump',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        email: payload.email,
        type: 'kpiDump',
        params: payload.params,
      },
    });
    return dispatch({
      type: DOWNLOAD_KPI_DATA_DUMP,
      payload: response.data,
    });
  } catch (error) {
    return dispatch({
      type: DOWNLOAD_KPI_DATA_DUMP,
      error,
    });
  }
};


export const fetchTotalMealImagesUploaded = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LOADING });
    }

    const response = await CLIENT({
      url: '/kpi/getTotalMealImagesUploaded',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
        
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_90_DAYS,
        payload: { loading: false, data: response.data, error: null },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_30_DAYS,
        payload: { loading: false, data: response.data, error: null },
      });
    }
    return dispatch({
      type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_90_DAYS,
        payload: { loading: false, data: null, error },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_LAST_30_DAYS,
        payload: { loading: false, data: null, error },
      });
    }
    return dispatch({
      type: FETCH_TOTAL_MEAL_IMAGES_UPLOADED_ERROR,
      error,
    });
  }
};


export const fetchTotalMealsAdded = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: FETCH_TOTAL_MEALS_ADDED_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: FETCH_TOTAL_MEALS_ADDED_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: FETCH_TOTAL_MEALS_ADDED_LOADING });
    }

    const response = await CLIENT({
      url: '/kpi/getTotalMealsAdded',
      method: 'POST',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });

    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: FETCH_TOTAL_MEALS_ADDED_LAST_90_DAYS,
        payload: { loading: false, data: response.data, error: null },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: FETCH_TOTAL_MEALS_ADDED_LAST_30_DAYS,
        payload: { loading: false, data: response.data, error: null },
      });
    }
    return dispatch({
      type: FETCH_TOTAL_MEALS_ADDED_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: FETCH_TOTAL_MEALS_ADDED_LAST_90_DAYS,
        payload: { loading: false, data: null, error },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: FETCH_TOTAL_MEALS_ADDED_LAST_30_DAYS,
        payload: { loading: false, data: null, error },
      });
    }
    return dispatch({
      type: FETCH_TOTAL_MEALS_ADDED_ERROR,
      error,
    });
  }
};

export const fetchTotalAICoachMessages = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: FETCH_TOTAL_AI_COACH_MESSAGES_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: FETCH_TOTAL_AI_COACH_MESSAGES_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: FETCH_TOTAL_AI_COACH_MESSAGES_LOADING });
    }

    const response = await CLIENT({
      url: '/kpi/getTotalAICoachMessages',
      method: 'POST',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: FETCH_TOTAL_AI_COACH_MESSAGES_LAST_90_DAYS,
        payload: { loading: false, data: response.data, error: null },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: FETCH_TOTAL_AI_COACH_MESSAGES_LAST_30_DAYS,
        payload: { loading: false, data: response.data, error: null },
      });
    }
    return dispatch({
      type: FETCH_TOTAL_AI_COACH_MESSAGES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: FETCH_TOTAL_AI_COACH_MESSAGES_LAST_90_DAYS,
        payload: { loading: false, data: null, error },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: FETCH_TOTAL_AI_COACH_MESSAGES_LAST_30_DAYS,
        payload: { loading: false, data: null, error },
      });
    }
    return dispatch({
      type: FETCH_TOTAL_AI_COACH_MESSAGES_ERROR,
      error,
    });
  }
};

export const fetchUniqueNutritionUsers = (payload) => async (dispatch, getState) => {
  try {
    if (payload.selectedFilter?.value === 'last90Days') {
      dispatch({
        type: FETCH_UNIQUE_NUTRITION_USERS_LAST_90_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else if (payload.selectedFilter?.value === 'last30Days') {
      dispatch({
        type: FETCH_UNIQUE_NUTRITION_USERS_LAST_30_DAYS,
        payload: { loading: true, data: null, error: null },
      });
    } else {
      dispatch({ type: FETCH_UNIQUE_NUTRITION_USERS_LOADING });
    }

    const response = await CLIENT({
      url: '/kpi/getUniqueNutritionUsers',
      method: 'POST',
      state: getState(),
      body: {
        viewedFrom: payload.viewedFrom,
        companyIdList: payload.companyIdList,
        startDate: payload.startDate,
        endDate: payload.endDate,
        quarterly: payload.quarterly,
        selectedFilterType: payload.selectedFilter?.value,
      },
    });

    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: FETCH_UNIQUE_NUTRITION_USERS_LAST_90_DAYS,
        payload: { loading: false, data: response.data, error: null },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: FETCH_UNIQUE_NUTRITION_USERS_LAST_30_DAYS,
        payload: { loading: false, data: response.data, error: null },
      });
    }
    return dispatch({
      type: FETCH_UNIQUE_NUTRITION_USERS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (payload.selectedFilter?.value === 'last90Days') {
      return dispatch({
        type: FETCH_UNIQUE_NUTRITION_USERS_LAST_90_DAYS,
        payload: { loading: false, data: null, error },
      });
    }
    if (payload.selectedFilter?.value === 'last30Days') {
      return dispatch({
        type: FETCH_UNIQUE_NUTRITION_USERS_LAST_30_DAYS,
        payload: { loading: false, data: null, error },
      });
    }
    return dispatch({
      type: FETCH_UNIQUE_NUTRITION_USERS_ERROR,
      error,
    });
  }
};


